import React, { useEffect, useState } from 'react';
import question from '../img/question.svg'
import DatePicker2 from '../components/Datepicker'
import { timeOptions } from '../js/businessHour'
import AlertWindow from '../components/Alert'
import { useDispatch, useSelector } from 'react-redux';
import { updateSearchData, setBookingId } from "../redux/data.js";
import { requestData } from '../js/api.js'
import dayjs from 'dayjs';

const formatDate = (dateStr) => dayjs(dateStr, 'MM/DD/YYYY').format('YYYY-MM-DD');

function SelectVehicle() {
  const dispatch = useDispatch();
  const searchData = useSelector((state) => state.data.searchData);
  const images = require.context('../img', false, /\.svg$/);
  const [alertMessage, setAlertMessage] = useState('')
  const [popSelectDate, setPopSelectDate] = useState(false)
  const [openAlert, setOpenAlert] = useState(false)
  const [featuresObj, setfeaturesObj] = useState({})
  const [branches, setBranches] = useState([])
  const [cartype, setCartype] = useState([])
  const [features, setFeatures] = useState([])
  const [loading, setLoading] = useState(true)
  const [vehiclePrice, setVehiclePrice] = useState({})
  const [newSearch, setNewSearch] = useState(false)
  const specs = { 'passengers': 'passgenrs', 'doors': 'doors', 'bags': 'bags', 'transmission': '', 'petrol_type': '' }

  const isFutureDate = () => {
    if (!searchData.startDate) return false;
    const start = new Date(`${searchData.startDate} ${searchData.startTime}`);

    const today = new Date();

    return start > today;
  };

  const searchVehicle = () => {
    if (isFutureDate()) {
      getCartype()
    } else {
      setAlertMessage('Please select a future date to book a car')
      setOpenAlert(true)
    }
  }

  const getCartype = async () => {
    try {
      setNewSearch(false)
      let data = await requestData('POST', `branches/vehicles`, {
        branch_id: searchData.pickup,
        startDateTime: `${formatDate(searchData.startDate)}T${searchData.startTime}`,
        endDateTime: `${formatDate(searchData.endDate)}T${searchData.endTime}`
      });
      if (data.success) {
        const customOrder = ['E', 'C', 'F', 'L'];

        const sortedData = data.data?.sort((a, b) => {
          const aLetter = a.sipp?.charAt(0) || '';
          const bLetter = b.sipp?.charAt(0) || '';
          const aIndex = customOrder.indexOf(aLetter);
          const bIndex = customOrder.indexOf(bLetter);

          return (aIndex === -1 ? Infinity : aIndex) - (bIndex === -1 ? Infinity : bIndex);
        });

        setCartype(sortedData);
        setFeatures(data.features)
        setVehiclePrice(data.price)
      } else {
        setAlertMessage(data.error)
        setOpenAlert(true)
      }
    } catch (error) {
      setAlertMessage(error.message)
      setOpenAlert(true)
    }
  };
  useEffect(() => {

    const fetchData = async () => {
      await getCartype();
      setLoading(false);
    };

    fetchData();
  }, []);   // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (features) {
      const featureMap = Object.fromEntries(
        features.map(f => [f.code, f.title])
      );
      setfeaturesObj(featureMap)
    }
  }, [features])

  const payVehicle = (cartype) => {
    if (searchData.startDate === '' || searchData.endDate === '') {
      setAlertMessage('Please select the start date and return date')
      setOpenAlert(true)
      return
    }
    dispatch(updateSearchData({ key: 'vehicleDetails', value: cartype }));
    dispatch(updateSearchData({ key: 'vehiclePrice', value: vehiclePrice[cartype?.vehicle_id] }));
    dispatch(setBookingId('extra'))
  }


  const changeSearchData = (key, val) => {
    dispatch(updateSearchData({ key: key, value: val }));
    setCartype([]);
    setFeatures([])
    setVehiclePrice({})
    setNewSearch(true)
  }

  const getDate = (selectedStartDate, selectedEndDate) => {
    dispatch(updateSearchData({ key: 'startDate', value: selectedStartDate }));
    dispatch(updateSearchData({ key: 'endDate', value: selectedEndDate }));
    setCartype([]);
    setFeatures([])
    setVehiclePrice({})
    setNewSearch(true)
  }

  const selectDateEvent = (event) => {
    if (event && event === 'check') {
      if (searchData.startDate === '' || searchData.endDate === '') {
        setAlertMessage('Please select the start date and return date')
        setOpenAlert(true)
        return
      }
    }
    setPopSelectDate(!popSelectDate)
  }

  const getBranch = async () => {
    try {
      let data = await requestData('GET', 'getbranch');
      setBranches(data)

    } catch (error) {
      console.error('Error:', error.message);
    }
  };

  useEffect(() => {
    getBranch()
  }, [])

  return (
    <div className='mt-4'>
      <div>
        <div class="pb-6 pt-2 text-start border-b-2 border-gray-200">
          <h2 class="text-2xl font-semibold mb-4">Select Date</h2>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div class="flex flex-col">
              <label className="text-sm font-medium text-gray-600">Pick-up Location</label>
              <select
                id="pickup-location"
                value={searchData.pickup}
                onChange={(e) => changeSearchData('pickup', e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              >
                <option value="">Select Branch</option>
                {branches
                  .filter((branch) => branch.status === 'available')
                  .map((branch) => (
                    <option key={branch.id} value={branch.id}>
                      {branch.name}
                    </option>
                  ))}
              </select>
            </div>
            <div class="flex flex-col">
              <label className="text-sm font-medium text-gray-600">Return Location</label>

              <select
                id="dropoff-location"
                value={searchData.dropoff}
                onChange={(e) => changeSearchData('dropoff', e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              >
                <option value="same_as_pickup">Same as pick up</option>
                {branches
                  .filter((branch) => branch.status === 'available')
                  .map((branch) => (
                    <option key={branch.id} value={branch.id}>
                      {branch.name}
                    </option>
                  ))}
              </select>
            </div>
            <div class="flex flex-col">
              <label className="text-sm font-medium text-gray-600">Age</label>
              <select
                id="driver-age"
                value={searchData.driverage}
                onChange={(e) => changeSearchData('driverage', e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              >
                <option value="25">25+</option>
                <option value="21-25">21-25</option>
                <option value="65">65+</option>
              </select>

            </div>
          </div>
          <div class="flex flex-col col-span-3 mt-4">
            <label className="text-sm font-medium text-gray-600">Pick-up Date & Time</label>
            <button type="button" onClick={selectDateEvent} className=" w-full text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm p-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700">
              {searchData.startDate ? searchData.startDate + ' ' + searchData.startTime + ' - ' + searchData.endDate + ' ' + searchData.endTime : 'Select the time'}
            </button>
          </div>

          {newSearch && <div className='text-primary text-sm'>* Please click the Search button whenever you change the search information.</div>}

          <div className="flex justify-end">
            <button
              type="button"
              onClick={searchVehicle}
              className="mt-4 text-white bg-primary hover:bg-primary/80 focus:ring-4 focus:ring-primary/50 font-medium rounded-lg text-sm px-5 py-2.5">
              Search
            </button>
          </div>
        </div>
      </div>
      <div>
        <h2 class="text-2xl font-semibold my-4 text-start">Select Vehicle</h2>
        {
          !loading && cartype?.map((item, idx) => (
            <div key={idx} className='my-4'>
              <label className="block relative text-left">
                <div className="w-full p-5 rounded-lg border bg-white/60 shadow-sm ring-primary peer-checked:ring-2 duration-200 relative">
                  <div className='block md:flex'>
                    <div className='w-[200px] mr-2'>
                      <img className='w-full h-full object-contain' alt='vehicleImg' src={item.vehicle_image ? item.vehicle_image : '/cardefault.png'} />
                    </div>
                    <div className='flex-1 flex flex-col'>
                      <div>{item.title}</div>
                      <div className='font-bold text-lg my-1'>{item.type}</div>
                      <div className="grid grid-cols-2 gap-x-4 text-sm mt-1">
                        {Object.keys(specs).map((i, id) => (
                          <div className='flex items-center' key={id + 'specs'}>
                            <img src={images(`./${i}.svg`)} className='w-4 h-4 mr-2' alt={i} />
                            <div>{item[i] + ' ' + specs[i]}</div>
                          </div>
                        ))}
                      </div>
                      <div className='group relative inline mt-2 inline-block'>
                        <span className='text-sm text-primary'>+ More Information</span>
                        <div className="py-1 px-2 rounded flex absolute z-[99] left-0 top-full mt-2 p-4 bg-primary text-white opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-300">
                          <div className='m-2 w-[50%] overflow-visible'>
                            <div className='capitalize font-bold'>Features</div>
                            <div className='flex-1'>
                              {item?.features && item?.features?.map((data, y) => (
                                <div key={y} className='whitespace-nowrap'>+ {featuresObj[data]}</div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='mt-6'>
                    <div className='flex space-between'>
                      <div className='font-bold text-md mr-2'>Pay Now</div>
                      <div className="relative group">
                        <img src={question} className='w-6 h-6' alt='question' />
                        <div className="absolute z-[99] md:whitespace-nowrap whitespace-normal mt-2 left-0 top-full py-1 px-2 rounded bg-gray-800 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                          If canceled 7 days in advance, there will be no cancellation fee.
                        </div>
                      </div>
                    </div>
                    <div className='md:flex block space-between'>
                      <div className='text-sm flex-1'>Confirmed your holiday plans? Pay for your rental today, to receive a discount on our standard industry rates. Easy Cancellation Fees Apply.</div>
                      <div className='md:w-[150px] text-end md:mt-0 mt-2'>
                        <div className="text-primary ">
                          <span className=''>AUD </span>
                          <span className='font-bold text-2xl text-primary italic'>{parseFloat(vehiclePrice[item.vehicle_id]).toFixed(2)}</span>
                        </div>
                        <button className="mt-2 bg-primary hover:bg-primary/80 text-white font-semibold px-5 py-2 rounded-lg" onClick={() => payVehicle(item)}>
                          Order Now
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
              </label>
            </div>
          ))
        }
        {loading && <div className='p-8 relative items-center'>
          <div role="status" class="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
            <svg aria-hidden="true" class="w-10 h-10 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
            <span class="sr-only">Loading...</span>
          </div>
        </div>}
      </div>

      {popSelectDate &&
        <div
          tabIndex="-1"
          className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-1 flex justify-center items-center w-full h-full bg-black/50"
        >
          <div className="relative p-4 w-full max-w-[46rem] max-h-full">
            <div className="relative bg-white rounded-lg shadow-sm dark:bg-gray-800">
              <div className="flex items-center justify-between p-4 border-b rounded-t dark:border-gray-700 border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Select Date & Time
                </h3>
                <button onClick={selectDateEvent} type="button" className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm h-8 w-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" >
                  <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              <div className="pt-0 flex md:flex-row flex-col ">
                <div className='mx-4 mb-4 flex-1'>
                  <label className="text-left uppercase font-bold text-sm text-gray-900 dark:text-white my-4 block">
                    Select the date
                  </label>
                  <DatePicker2 getDate={getDate} searchData={searchData} />
                </div>
                <div className='mx-4 flex-1'>
                  <label className="text-left uppercase font-bold text-sm text-gray-900 dark:text-white my-4 block">
                    Pick up time
                  </label>
                  <select id="startTime" value={searchData.startTime} onChange={(val) => changeSearchData('startTime', val.target.value)} className="my-2 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                    {timeOptions?.map((slot) => (
                      <option key={slot.key + 'start'} value={slot.key}>
                        {slot.title}
                      </option>
                    ))}
                  </select>

                  <label className="text-left uppercase font-bold text-sm text-gray-900 dark:text-white my-4 block">
                    drop off time
                  </label>
                  <select id="endTime" value={searchData.endTime} onChange={(val) => changeSearchData('endTime', val.target.value)} className="my-2 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                    {timeOptions?.map((slot) => (
                      <option key={slot.key + 'end'} value={slot.key}>
                        {slot.title}
                      </option>
                    ))}

                  </select>
                  <div className="grid grid-cols-2 gap-2 my-5">
                    <div></div>
                    <button
                      type="button"
                      onClick={() => selectDateEvent('check')}
                      className=" text-white bg-primary hover:bg-primary/80 focus:ring-4 focus:ring-primary/50 font-medium rounded-lg text-sm px-5 py-2.5 mb-2">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      <AlertWindow setOpenAlert={setOpenAlert} openAlert={openAlert} message={alertMessage} />
    </div>
  )
}

export default SelectVehicle;